import type { SceneObjectData, SceneSettings } from "../types";

interface SharedScenePayload {
  objects: SceneObjectData[];
  settings: SceneSettings;
}

export async function createShare(objects: SceneObjectData[], settings: SceneSettings): Promise<string> {
  const response = await fetch("/api/scenes", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ objects, settings }),
  });
  if (!response.ok) throw new Error(`Share fehlgeschlagen: ${response.status}`);
  const { id } = (await response.json()) as { id: string };
  return `${window.location.origin}/s/${id}`;
}

export async function fetchSharedScene(id: string): Promise<SharedScenePayload> {
  const response = await fetch(`/api/scenes/${id}`);
  if (!response.ok) throw new Error(`Szene nicht gefunden: ${response.status}`);
  return response.json();
}
